import React from "react";
import { Labelbox } from "..";
import { getBusinessSelectionId } from "../../utils/businessDocumentContext";
import "./client-business-selector.scss";

export default function ClientBusinessSelector({
  businesses = [],
  value,
  onChange,
  label = "Select Business",
}) {
  if (!businesses.length) return null;

  const dropdown = businesses.map((business) => {
    const id = getBusinessSelectionId(business);
    return {
      id,
      value: business.is_primary
        ? `${business.business_name} (Primary)`
        : business.business_name,
    };
  });

  return (
    <div className="client-business-selector">
      <Labelbox
        type="select"
        labelname={label}
        value={value != null ? String(value) : ""}
        dropdown={dropdown}
        changeData={(next) => onChange?.(next != null ? String(next) : "")}
      />
    </div>
  );
}
